<div class="row mx-0 align-items-center">
  <button class="q-btn q-main" (click)="CreateContract()" [disabled]="!IdFormateurSelected || IdFormateurSelected == ''" *ngIf="!IsGenerate"><i class="fas fa-save mr-2"></i>Générer</button>
  <button class="q-btn q-main" *ngIf="IsGenerate"><i class="fas fa-spin fa-spinner fa-pulse mr-2"></i>Génération en cours</button>
  <!--#region bouton-->

  <div class="col-auto rounded-button ml-1 q-pointer"
       [ngClass]="[emptyModel ? 'q-danger' : 'q-dark-secondary']"
       placement="bottom bottom-left bottom-right auto"
       [autoClose]="'outside'"
       [ngbPopover]="f4"
       #p4="ngbPopover"
       popoverClass="q-popover"
       [title]="SelectedModel.value">
    <span>
      <span class="q-bold">Modèle : </span>
      <span>{{SelectedModel.value}}</span>
    </span>
  </div>
  <!--#endregion-->
  <!--#region popovers spécifiques à chaque format de valeur-->
  <ng-template #f4>
    <!--#region popover générique pour les combos-->
    <ng-container *ngIf="ModelsList && ModelsList.length > 0">
      <!--<div class="q-hover q-pointer px-2" (click)="SelectedModel.id = '' ; SelectedModel.value = '- - - - - -'; p4.close()">- - - - - -</div>-->
      <ng-container *ngFor="let combo of ModelsList; let i = index">
        <div class="q-hover q-pointer px-2" (click)="emptyModel = false; SelectedModel.id = combo.id ; SelectedModel.value = combo.value; p4.close()">{{combo.value}}</div>
      </ng-container>
    </ng-container>
    <!--#endregion-->
  </ng-template>
  <!--#endregion-->
  <q-dynamictags-inline #dynamictagsInline
                        class="col pl-0"
                        idDonnee="0" codeOrIdBo="BO_CNT"
                        [exceptColumnNames]="['Type_DOC', 'Path_DOC', 'DtcreDOC']"></q-dynamictags-inline>
</div>

<div class="row q-bloc-cnt my-4">
  <div class="col-12 col-lg-6 col-xl-3" style="min-height: 350px;">
    <q-effectifs [Option]="OptionFormateur" (EffectifToEmit)="GetFormateur($event)" [show]="docService.tabs[2].Active"></q-effectifs>
  </div>
  <div class="col-12 col-lg-6 col-xl-3" *ngIf="IdFormateurSelected && IdFormateurSelected != ''">
    <fieldset class="q-fieldset h-100">
      <legend><i class="fas fa-file-contract"></i> Contrat</legend>
      <div class="row">
        <div class="col-12 col-lg-6">
          <h5 class="q-bo-grouptitle">Calcul Facturation</h5>
          <label class="q-bo-label mt-1"> Coût formateur</label>
          <div class="input-group input-group-sm">
            <input class="col q-input-border q-bo q-bg-input-contract" aria-label="Small"
                   [(ngModel)]="CoutFormateur">
          </div>
          <label class="q-bo-label mt-1"> Mode calcul en jour</label>
          <div id="switch" class="checkbox checbox-switch switch-primary">
            <label>
              <input type="checkbox" [checked]="ModeCalculJour" (change)="ModeCalculJour = !ModeCalculJour" />
              <span></span>
            </label>
          </div>
          <label class="q-bo-label mt-1"> Nb heure stage</label>
          <div class="input-group input-group-sm">
            <input class="col q-input-border q-bo q-bg-input-contract" aria-label="Small"
                   [(ngModel)]="NbHeureStage">
          </div>
          <label class="q-bo-label mt-1"> Nb de jour</label>
          <div class="input-group input-group-sm">
            <input class="col q-input-border q-bo q-bg-input-contract" aria-label="Small"
                   [(ngModel)]="NbJour">
          </div>
          <label class="q-bo-label mt-1"> Taux de TVA</label>
          <div class="input-group input-group-sm">
            <input class="col q-input-border q-bo q-bg-input-contract" aria-label="Small"
                   [(ngModel)]="TauxTVA">
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <h5 class="q-bo-grouptitle">Comptabilité</h5>
          <label class="q-bo-label mt-1"> Montant HT</label>
          <div class="input-group input-group-sm">
            <input class="col q-input-border q-bo q-input-disabled q-bg-input-contract" aria-label="Small"
                   value="{{CalculMontantHT()}}" disabled>
          </div>
          <label class="q-bo-label mt-1"> Montant TVA</label>
          <div class="input-group input-group-sm">
            <input class="col q-input-border q-bo q-input-disabled q-bg-input-contract" aria-label="Small"
                   value="{{CalculTauxTVA()}}" disabled>
          </div>
          <label class="q-bo-label mt-1"> Montant TTC</label>
          <div class="input-group input-group-sm">
            <input class="col q-input-border q-bo q-input-disabled q-bg-input-contract" aria-label="Small"
                   value="{{CalculMontantTTC()}}" disabled>
          </div>
        </div>
      </div>
    </fieldset>
  </div>


  <div class="col-12 col-lg-12 col-xl-6" *ngIf="IdFormateurSelected && IdFormateurSelected != '' && docService.tabs[2].Active">
    <queoval-stage-list-reservation [IdentFormateur]="IdFormateurSelected" (LstIdReservation)="GetReservations($event)"></queoval-stage-list-reservation>
  </div>
</div>



<button class="btn q-btn q-danger m-1" type="button" (click)="open(ModalDeleteValidation, false)"
        title="Supprimer les documents sélectionnés" [disabled]="!selectedNodes || !selectedNodes?.length || selectedNodes.length < 1">
  <i class="fas fa-trash-alt"></i>
</button>

<!--<button title="Regénérer le document" class="btn q-btn m-1" (click)="open(ModalGenerateValidation, false)" [disabled]="!selectedNodes || !selectedNodes?.length || selectedNodes.length < 1">
  <i class="fas fa-print"></i> Regénérer doc
</button>-->


<q-customgrid customgridName="ListContratFormateur"
              [idDonnee]="service.Stage.Ident"
              [(refreshData)]="refreshData"
              (selectChanged)="selectLine($event)">
</q-customgrid>


<!--  MODAL de validation de la suppression des documents -->
<ng-template #ModalDeleteValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Etes-vous sûr de vouloir supprimer définitivement ces documents ?</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="DeleteSelection();modal.dismiss()"
              title="Supprimer les documents" [disabled]="!selectedNodes?.length">
        Supprimer
      </button>
    </div>
  </div>
</ng-template>

<!--  MODAL de validation de regénération des documents -->
<ng-template #ModalGenerateValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Attention ! Vous allez remplacer les documents sélectionnés existants.</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <button class="btn q-btn m-2" type="button" (click)="RegenereDoc();modal.dismiss()"
              title="Générer les documents" [disabled]="!selectedNodes?.length">
        OK
      </button>
    </div>
  </div>
</ng-template>



